import { useCustomToast } from '@elkaso-app/web-design';
import http from 'apis/config/http-service';
import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import type { UseMutationOptions, UseMutationResult } from 'react-query';
import { useGetSupplierItemsApi } from './use-get-supplier-items-api';

const endpoint = 'catalog/v1/legacy-products/activate/bulk';

type TData = Record<string, any>;
type TError = AxiosError;

type BodyType = {
  ids: string[];
  isActive: boolean;
};

type TVariables = {
  body: BodyType;
};

type Options = Omit<UseMutationOptions<TData, TError, TVariables, unknown>, 'mutationFn'>;
type ReturnType = UseMutationResult<TData, TError, TVariables, unknown>;

export function useActivateDeactivateItemsApi(options?: Options): ReturnType {
  const { refetch: refetchSupplierItems } = useGetSupplierItemsApi({
    enabled: false,
  });

  const toast = useCustomToast();
  let fullEndpoint;

  const mutationFn = async ({ body }: TVariables) => {
    fullEndpoint = `${endpoint}`;

    try {
      const { data } = await http.patch(fullEndpoint, body);
      // Refetch supplier items
      refetchSupplierItems();

      toast({
        description: `Items have been ${body.isActive ? 'activated' : 'deactivated'} successfully`,
        status: 'success',
      });

      return data;
    } catch (error: any) {
      if (!error.response.status || !error.response.data.message) throw error;

      toast({
        description: error.response.data.message,
        status: 'error',
      });

      throw error;
    }
  };

  return useMutationWrapper(mutationFn, { mutationKey: fullEndpoint, ...options });
}
